import Header from '../../organisms/Header/Header'
import { Button, Cards, CustomIcon } from 'ams-ui-reactkit';
import { Typography } from "@material-ui/core";
import DynamicHtml from "../../molecules/DynamicHtml"
import { TemplateProps } from '../../journeys/journey/Interfaces';
import { LetsFinalizeImage, UserProfile } from '../../assets/images';
import './ThankYou.scss'
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from '../../context';
import VCard from 'vcard-creator';
import vCardsJS from 'vcards-js';

const ThankYou: React.FC<TemplateProps> = (props: any) => {
    const customerInfoState: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);
    const { templateProps } = props;
    console.log("templateProps:", templateProps);
    const { script, content, link, iconname } = templateProps;

    const downloadVCard = () => {
        fetch('https://s3.amazonaws.com/cdn.allmysons.com/vcard.vcf', {
            method: 'GET',
            headers: {
                'Content-Type': 'text/vcard',
            }
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `vcard.vcf`,
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link?.parentNode?.removeChild(link);
            });
    }

    const isIphone = () => {
        const ua = navigator.userAgent
        if (/iPad|iPhone|iPod/.test(ua)
            || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            return true
        }
        return false;
    }

    function downloadToFile(content: any, filename: any, contentType: string) {
        const link = document.createElement('a');
        const file = new Blob([content], { type: contentType });

        link.href = URL.createObjectURL(file);
        link.download = filename;
        link.click();

        console.log(link.href);
        URL.revokeObjectURL(link.href);
    }

    const generateVCF123 = () => {
        var vCard = vCardsJS();
        vCard.firstName = 'All My Sons Moving';
        vCard.workPhone = customerInfoState?.BranchPhone;
        console.log(vCard.getFormattedString());
        downloadToFile(vCard.getFormattedString(), 'ams.vcf', 'text/vcard');
    }
    const generateVCF = () => {
        const vcf = new VCard();

        const firstname = 'All My Sons Moving'
        const lastname = ''
        const additional = ''
        const prefix = ''
        const suffix = ''

        vcf.addName(lastname, firstname, additional, prefix, suffix)
            //.addCompany('Siesqo')
            //.addJobtitle('Web Developer')
            //.addRole('Data Protection Officer')
            //.addEmail(customerInfoState?.BranchEmail)
            .addPhoneNumber(customerInfoState?.BranchPhone, 'PREF;WORK')
        //.addPhoneNumber(123456789, 'WORK')
        // .addAddress("null", "null", 'street', 'worktown', "null", 'workpostcode', 'Belgium')
        // .addSocial('https://twitter.com/desloovere_j', 'Twitter', 'desloovere_j')
        // .addURL('http://www.jeroendesloovere.be')

        console.log(vcf.toString());

        downloadToFile(vcf.toString(), 'ams.vcf', 'text/vcard');
    }

    const cardContent = (iconName: string, selectedOption: any) => {
        if (iconname === "allset") {
            return (
                <Cards variant="default">
                    <Typography variant="subtitle2" component="span" className="thankYoucontent">
                        <DynamicHtml tagName="div" content={content?.title} />
                    </Typography>
                </Cards>
            )
        }
        if (selectedOption === 0 || selectedOption === 1) {
            return (
                <div className="thankYouPageCard">
                    {
                        content?.label && (
                            <Cards variant="default">
                                <div>
                                    <Typography variant="subtitle2" component="span" className="thankYoucontent">
                                        <DynamicHtml tagName="div" content={content?.title} />
                                    </Typography>
                                    <div className='containerHighlightBlock'>
                                        <div className='containerHighlightBlockInr' style={{ cursor: "pointer" }} onClick={() => { generateVCF() }}>
                                            <div>
                                                <img src={UserProfile} />
                                            </div>
                                            <div>
                                                <Typography variant="subtitle2" component="span" className="thankYoucontent">
                                                    <DynamicHtml tagName="div" content={content?.label} />
                                                </Typography>
                                            </div>
                                            <div className='highLightIcon'>
                                                <CustomIcon iconName="ArrowForwardIos" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Cards>
                        )
                    }
                </div>
            )
        } else {
            return (
                <Cards variant="default">
                    {
                        (customerInfoState?.FVPOption === 2 && link) &&
                        <div style={{ marginBottom: "24px", marginTop: '8px' }}>
                            <DynamicHtml tagName="div" content={link} />
                        </div>
                    }
                    <div className="thankYouPageCard">
                        {
                            content?.label && (
                                <div>
                                    <Typography variant="subtitle2" component="span" className="thankYoucontent">
                                        <DynamicHtml tagName="div" content={content?.title} />
                                    </Typography>
                                    <div className='containerHighlightBlock'>
                                        <div className='containerHighlightBlockInr' style={{ cursor: "pointer" }} onClick={() => { generateVCF() }}>
                                            <div>
                                                <img src={UserProfile} />
                                            </div>
                                            <div>
                                                <Typography variant="subtitle2" component="span" className="thankYoucontent">
                                                    <DynamicHtml tagName="div" content={content?.label} />
                                                </Typography>
                                            </div>
                                            <div className='highLightIcon'>
                                                <CustomIcon iconName="ArrowForwardIos" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </Cards>
            )
        }
    }
    return (
        <div className='full-block thankyouScreen'>
            <div className="outlineContainer">
                <div className="baseContainerBlock">
                    <div>
                        <Cards variant="primary">
                            <div className="thankyoumainblock">
                                <div className="thankyouimg">
                                    <CustomIcon iconName={iconname} />
                                </div>
                                <Typography variant="body2" component="span" className="thankyoudesc">
                                    <DynamicHtml tagName="div" content={script} />
                                </Typography>
                            </div>
                        </Cards>
                    </div>

                    {
                        cardContent(iconname, customerInfoState?.FVPOption)
                    }
                    {/* <Cards variant="default">
                        {
                            (customerInfoState?.FVPOption === 2 && link) &&
                            <div style={{ marginBottom: "24px", marginTop: '8px' }}>
                                <DynamicHtml tagName="div" content={link} />
                            </div>
                        }
                        <div className="thankYouPageCard">
                            {
                                content?.label && (
                                    <div>
                                        <Typography variant="subtitle2" component="span" className="thankYoucontent">
                                            <DynamicHtml tagName="div" content={content?.title} />
                                        </Typography>
                                        <div className='containerHighlightBlock'>
                                            <div className='containerHighlightBlockInr' style={{ cursor: "pointer" }} onClick={() => { generateVCF() }}>
                                                <div>
                                                    <img src={UserProfile} />
                                                </div>
                                                <div>
                                                    <Typography variant="subtitle2" component="span" className="thankYoucontent">
                                                        <DynamicHtml tagName="div" content={content?.label} />
                                                    </Typography>
                                                </div>
                                                <div className='highLightIcon'>
                                                    <CustomIcon iconName="ArrowForwardIos" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </Cards> */}
                </div>
            </div >
        </div >
    )
}

export default ThankYou